<template>
  <section>
    <label class="block">
      <span class="text-gray-smoke font-semibold text-xs mb-2 block">
        <slot></slot>
      </span>
      <!-- class="form-input mt-1 block w-full" -->
      <input
        class="w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor text-gray-slate focus:outline-none rounded-md"
        :class="classStr"
        :type="type"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :placeholder="placeholder"
      />
    </label>
  </section>
</template>

<script>
export default {
  props: {
    type: String,
    placeholder: String,
    value: String,
    classStr: Object,
  },
  data() {
    return {};
  },
};
</script>